import { Form, Input, Segmented } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../../../../store/user/selectors";
import Modal from "../../../../components/generic/Modal";
import { addEditFileFolder } from "../../../../store/spreadsheet/thunks";
import { AppstoreOutlined, FolderOutlined } from "@ant-design/icons";

const AddEditModal = (props) => {
  const { onCancel, folder_id, selectedRecord } = props;

  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const selectedTenantId = useSelector(selectSelectedTenantId);

  const isEdit = useMemo(() => !!selectedRecord?.id, [selectedRecord]);

  useEffect(() => {
    if (selectedRecord?.id) {
      form.setFieldsValue({
        name: selectedRecord?.name,
        type: selectedRecord?.isFile ? "workbook" : "folder",
      });
    }
  }, [selectedRecord]);

  const type = Form.useWatch("type", form);

  const handleSubmit = useCallback(
    async ({ name, type }) => {
      try {
        setSubmitting(true);

        await dispatch(
          addEditFileFolder({
            name,
            tenant_id: selectedTenantId,
            type: isEdit ? "rename" : type,
            folder_id:
              selectedRecord?.isFile || !isEdit
                ? folder_id
                : selectedRecord?.id,
            workbook_id: selectedRecord?.isFile
              ? selectedRecord?.id
              : undefined,
          }),
        );

        onCancel();
      } finally {
        setSubmitting(false);
      }
    },
    [dispatch, onCancel, selectedTenantId, folder_id, isEdit, selectedRecord],
  );

  return (
    <Modal
      isProcessing={submitting}
      title={`${isEdit ? "Rename" : "Create"} ${type === "workbook" ? "Workbook" : "Folder"}`}
      onCancel={onCancel}
      width={400}
      onOk={() => form.submit()}
      open
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        disabled={submitting}
        initialValues={{
          type: folder_id ? "workbook" : "folder",
        }}
      >
        <Form.Item label="Type" name="type">
          <Segmented
            block
            options={[
              ...(!folder_id
                ? [
                    {
                      label: "Folder",
                      value: "folder",
                      icon: <FolderOutlined />,
                    },
                  ]
                : []),
              {
                label: "Workbook",
                value: "workbook",
                icon: <AppstoreOutlined />,
              },
            ]}
            disabled={isEdit}
          />
        </Form.Item>

        <Form.Item
          label={`${type === "workbook" ? "Workbook" : "Folder"} Name`}
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter a name",
            },
          ]}
        >
          <Input
            prefix={
              type === "workbook" ? <AppstoreOutlined /> : <FolderOutlined />
            }
            placeholder={`Enter ${type || ""} name`}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEditModal;
